import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { Output, EventEmitter } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { DiscussionsService } from '../../../services/discussions.service';
import { AuthenticationService } from '../../../services/authentication.service';

@Component({
  selector: 'app-discussions-active-users',
  templateUrl: './discussions-active-users.component.html',
  styleUrls: ['./discussions-active-users.component.scss']
})
export class DiscussionsActiveUsersComponent implements OnInit {

    constructor(private authentication: AuthenticationService, private _router: Router, private _commonService: CommonService, private discussionsService: DiscussionsService) { }

    ngOnInit(): void {
        this.getActiveUsers();
    }

    activeUsers: any[] = [];

    getActiveUsers() {

        this.discussionsService.getActiveUsers().subscribe(
            (res: any) => {
                if (res.success) {
                    this.activeUsers = res.data;
                }
                else {
                    console.error("Discussions/Top Contributors box", res.error_message);
                }
            },
            (err: any) => {
                console.error("Discussions/Top Contributors box", err);
            }
        );
    }

    openUserProfile(userId: any) {
        this._router.navigate(['/profile/user-profile/' + userId]);
    }
}
